var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoldOutRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33.9997,
    height: 34.0017,
    rx: 5,
    fill: "#FFD1D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8484 12.8896L23.1488 11.1334L24.3322 9.91049C24.534 9.70197 24.534 9.36492 24.3322 9.15639C24.1304 8.94787 23.8043 8.94787 23.6025 9.15639L16.3955 16.6035C16.5281 16.7161 16.6556 16.8355 16.7785 16.9619C16.9013 17.0888 17.0164 17.2206 17.1253 17.3576L20.3546 14.0207L22.0541 15.7769C22.1548 15.8809 22.2869 15.9332 22.419 15.9332C22.5511 15.9332 22.6833 15.8809 22.7839 15.7769L24.8484 13.6437C25.0502 13.4351 25.0502 13.0981 24.8484 12.8896Z",
    fill: "#FF000B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0485 17.7183C15.2687 16.9125 14.2318 16.4688 13.1289 16.4688C12.026 16.4688 10.9891 16.9125 10.2092 17.7183C9.4294 18.5241 9 19.5955 9 20.7352C9 21.8749 9.4294 22.9463 10.2092 23.7522C10.9891 24.558 12.026 25.0017 13.1289 25.0017C14.2318 25.0017 15.2687 24.558 16.0485 23.7522C16.8284 22.9463 17.2578 21.8749 17.2578 20.7352C17.2578 19.5955 16.8284 18.5241 16.0485 17.7183Z",
    fill: "#FF000B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldOutRooms);
export default __webpack_public_path__ + "static/media/sold_out_Rooms.be5800ee57c853de6fb3cc937567d6b0.svg";
export { ForwardRef as ReactComponent };